// TODO: TRANSLATION PATTERN
// TODO: REFACTORING
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { Creators as Address } from '@store/reducers/address/reducer';
import { getAddresses, addAddress } from '@store/reducers/address/operations';
import { setBillingAddress } from '@store/reducers/cart/operations';
import BillingAddress from '@components/BillingAddress';
import SavedAddresses from '@components/SavedAddresses';
import Loader from '@components/Loader';
import * as Styled from './CreditCardAddress.styles';

import { translate as t } from '@utils/translate';

const CreditCardAddress = ({ isOpened, onClose, onSave, isEdit, onUpdate }) => {
  const dispatch = useDispatch();
  const { addresses, isFetching } = useSelector(state => state.address);
  const [isPanelOpened, setIsPanelOpened] = useState(false);
  const [panelState, setPanelState] = useState(null);
  const [addressPicked, setAddressPicked] = useState(false);
  const TEXTS = {
    WAITING_MSG: t('waitingDataValidation'),
    NEW_ADDRESS: t('addAddressForInvoice'),
    UPDATE_ADDRESS: t('updateToProceed'),
    EDIT_ADDRESS: t('editAddress'),
    BILLING_ADDRESS: t('billingAddress'),
  };

  useEffect(() => {
    if (isFetching === 'fetched') {
      dispatch(Address.setStatus(null));
      onSave(addresses[0]);
    }
  }, [isFetching]);

  useEffect(() => {
    if (!isOpened && isPanelOpened) {
      setPanelState('closed');

      setTimeout(() => {
        setIsPanelOpened(false);
      }, 700);
    } else if (isOpened) {
      setPanelState('opened');
      setIsPanelOpened(true);
    }
  }, [isOpened]);

  function handlePickAddress(id) {
    setAddressPicked(id);
    dispatch(setBillingAddress(findAddress(id)));
  }

  function saveAddress(data) {
    if (!addressPicked) {
      dispatch(Address.setStatus('fetching'));
      dispatch(addAddress(data));
    } else {
      onSave(findAddress(addressPicked));
    }
  }

  function findAddress(id) {
    return addresses.find(address => address.id === id) || null;
  }

  return (
    <>
      {isPanelOpened ? (
        <Styled.Wrapper>
          <Styled.Overlay state={panelState} />
          <Styled.Panel state={panelState}>
            {isFetching === 'fetching' ? (
              <Loader>
                <p>{TEXTS.WAITING_MSG}</p>
              </Loader>
            ) : null}
            <Styled.CloseButton onClick={onClose} />
            <Styled.SavedAddressesWraper>
              {addresses && addresses.length ? (
                <SavedAddresses data={addresses} onPick={handlePickAddress} />
              ) : null}
            </Styled.SavedAddressesWraper>
            <Styled.BillingAddressWrapper>
              <BillingAddress
                isDisabled={!!addressPicked}
                title={isEdit ? TEXTS.EDIT_ADDRESS : TEXTS.BILLING_ADDRESS}
                subtitle={isEdit ? TEXTS.UPDATE_ADDRESS : TEXTS.NEW_ADDRESS}
                onCancel={onClose}
                onSave={saveAddress}
                isEdit={isEdit}
                onUpdate={onUpdate}
              />
            </Styled.BillingAddressWrapper>
          </Styled.Panel>
        </Styled.Wrapper>
      ) : null}
    </>
  );
};

CreditCardAddress.propTypes = {
  isOpened: PropTypes.bool,
};

CreditCardAddress.defaultProps = {
  isOpened: true,
};

export default CreditCardAddress;
